import * as Onboarding from '../_layout/OnboardingComponents'
import { IdentityVerificationContent } from './_layout/IdentityVerificationContent'
import { IdentityVerificationSideMenu } from './_layout/IdentityVerificationSideMenu'

function IdentityVerificationPage() {
  return (
    <Onboarding.Container>
      <Onboarding.ContainerContent>
        <IdentityVerificationContent />
      </Onboarding.ContainerContent>

      <Onboarding.ContainerSideMenu>
        <IdentityVerificationSideMenu />
      </Onboarding.ContainerSideMenu>
    </Onboarding.Container>
  )
}

export default IdentityVerificationPage
